import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { Brain, Search, FileText, TrendingUp, MessageSquare, Eye, Upload, BarChart } from "lucide-react";

export function AIAdvancements() {
  const advancements = [
    {
      icon: MessageSquare,
      title: "AI Assistant & Analytics",
      subtitle: "An always-on AI chatbot that powers operational decisions.",
      features: [
        "Natural language commands",
        "Real-time answers to procurement/scheme KPIs",
        "Workflow trigger suggestions",
        "Smart dashboard integration"
      ]
    },
    {
      icon: Search,
      title: "Intelligent Gap Analysis",
      subtitle: "Catch what others miss—automated analysis of scheme and ToT inefficiencies.",
      features: [
        "AI detection of low-performing rules or outdated parameters",
        "Real-time suggestions with contextual insights",
        "Visual heatmaps and drill-downs"
      ]
    },
    {
      icon: FileText,
      title: "Document & Email Parsing",
      subtitle: "Eliminate manual entry—let AI convert contracts and emails into structured agreements.",
      features: [
        "Advanced NLP extraction",
        "Real-time ToT population",
        "Template-matched accuracy"
      ]
    },
    {
      icon: TrendingUp,
      title: "Predictive Forecasting & Optimization",
      subtitle: "Take proactive action using future insights, not just history.",
      features: [
        "SKU-level demand prediction",
        "Smart safety stock thresholds",
        "Lead time optimization across suppliers",
        "Promotion performance forecasting"
      ]
    }
  ];

  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <Badge variant="secondary" className="mb-4">
            <Brain className="mr-1 h-3 w-3" />
            AI Powered
          </Badge>
          <h2 className="mb-4 text-3xl lg:text-4xl text-black font-bold">AI Advancements</h2>
          <p className="text-lg text-muted-foreground">
            Cutting-edge artificial intelligence capabilities that transform how you interact with your procurement data.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {advancements.map((advancement, index) => (
            <Card key={index} className="border-primary/10 bg-background/50 backdrop-blur-sm">
              <CardHeader>
                <div className="mb-3 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary text-secondary-foreground">
                    <advancement.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <CardTitle className="text-lg">{advancement.title}</CardTitle>
                  </div>
                </div>
                <CardDescription>{advancement.subtitle}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {advancement.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2 text-sm">
                      <div className="h-1.5 w-1.5 rounded-full bg-secondary"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}